// Skeleton-loading primitives (CLAUDE.md: skeleton loading is part of the shell).
// The `.skeleton` shimmer is defined in theme.css.
export function Skeleton({ width, height, radius = 8, style }: { width?: number | string; height?: number | string; radius?: number; style?: React.CSSProperties }) {
  return (
    <span
      className="skeleton"
      aria-hidden="true"
      style={{ display: 'block', width: width ?? '100%', height: height ?? 16, borderRadius: radius, ...style }}
    />
  );
}

// A grid of card-shaped skeletons for the listing rails while data loads.
export function CardGridSkeleton({ count = 6 }: { count?: number }) {
  return (
    <div className="grid-cards" aria-busy="true" aria-label="Loading">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="card" style={{ padding: 12 }}>
          <Skeleton height={150} radius={12} />
          <div style={{ height: 10 }} />
          <Skeleton width="70%" height={14} />
          <div style={{ height: 8 }} />
          <Skeleton width="40%" height={12} />
        </div>
      ))}
    </div>
  );
}
